const form = {
    state: {
        entryDate: '',//回国日期
        preDate:'',//出国日期
        countryNameList:'',
        optionCountryList:'',//可选国家列表
        isFullscreen:null,
        getWorkLetterId:'',
    },
    namespaced:true,
    mutations: {
        SET_DATE: (state, date) => {
            state.entryDate = date.entryDate;
            state.preDate = date.preDate;
        },
        SET_COUNTRYLIST: (state, data) => {
            state.countryNameList = data
        },
        SET_OPTION_COUNTRYLIST:(state,data) => {
            state.optionCountryList = data;
        },
        SET_iSFUllSCREEN(state,data){
            state.isFullscreen = data;
        },
        SET_WORKLETTERID(state,data){
            state.getWorkLetterId = data;
        }
    },
    actions: {
        setDate: function ({commit},time) {
          commit("SET_DATE",time)
        },
        setFullscreen: function ({commit},data) {
            commit("SET_iSFUllSCREEN",data)
        },
        setWorkLetterId:function ({commit},data) {
            commit("SET_WORKLETTERID",data)
        },
        setCountryList: function ({commit},data) {
            commit("SET_COUNTRYLIST",data)
        },
        setOptionCountryList:function ({commit},data) {
            commit("SET_OPTION_COUNTRYLIST",data)
        },
    },

};

export default form;